/*
 * Dev-only logger.
 *
 * Wraps console.log so that debug logging stays available during local
 * development but is silenced in production builds (NODE_ENV === 'production').
 *
 * All direct console.error / console.warn calls have been routed through here: they were
 * leaking backend error payloads and stack details into the production console. Errors
 * that genuinely need visibility go to Sentry via utils/monitoring.js instead, which is
 * structured and off by default.
 */
const isDev = process.env.NODE_ENV !== 'production';

export const logger = {
    log: (...args) => {
        if (isDev) {
            console.log(...args);
        }
    },
};

export default logger;
